<template>
  <base-extra :extra="extra">
    <template #price>
      <pu-price
        v-if="!isVariable"
        :price="extra.price"
        :display-original-price="true"
      />
      <translate v-if="isVariable" class="per-stay"> price varies </translate>
      <translate
        v-else-if="isPerPeriod"
        class="per-stay"
        :tt="{ nights: extra.pricingPeriod }"
      >
        per {nights}
      </translate>
      <span v-else class="per-stay">{{ extra.pricingType.name }}</span>
    </template>
  </base-extra>
</template>

<script lang="ts">
import type { ChargeTypeExtra } from '../../../../campsite-details/types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class ExtraNonDated extends Vue {
  @Prop({ required: true })
  extra: ChargeTypeExtra

  get isPerPeriod() {
    return this.extra.pricingType.slug === 'per_period'
  }

  get isVariable() {
    return this.extra.isVariable
  }
}

export default toNative(ExtraNonDated)
</script>
